import styled from 'styled-components';
import { em } from 'styles';

export const Content = styled.div`
  margin: ${em(20)} 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
